import { forwardRef } from 'react';
import { Tooltip as AntdToolTip } from 'antd';

const ToolTip = forwardRef(
	(
		{
			children,
			title,
			mouseEnterDelay,
			trigger,
			align,
			placement,
			defaultOpen,
			color,
			overlayStyle,
			overlayInnerStyle,
			style,
			classNames,
		},
		ref,
	) => {
		return (
			<AntdToolTip
				title={title}
				mouseEnterDelay={mouseEnterDelay}
				trigger={trigger}
				align={align}
				placement={placement ? placement : 'bottom'}
				defaultOpen={defaultOpen}
				color={color}
				styles={{
					root: overlayStyle,
					container: overlayInnerStyle,
				}}
				classNames={classNames}
			>
				<span
					ref={ref}
					style={{ display: 'inline-flex', alignItems: 'center', ...style }}
				>
					{children}
				</span>
			</AntdToolTip>
		);
	},
);

ToolTip.displayName = 'ToolTip';

export default ToolTip;
